import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const NotificacaoContext = createContext();

export const NotificacaoProvider = ({ children }) => {
  const [notificacoes, setNotificacoes] = useState([]);
  const [naoLidas, setNaoLidas] = useState(0);
  const [userId, setUserId] = useState(null);
  const [erroAPI, setErroAPI] = useState(false);

  const atualizarUserId = (id) => {
    setUserId(id);
  };

  const carregarNotificacoes = async () => {
    if (!userId || userId === "undefined") return;

    try {
      const user = sessionStorage.getItem("user");
      if (!user) return;

      const { access_token } = JSON.parse(user);
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/notificacoes/usuario/${userId}`, {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
          'Authentication': access_token
        },
      });
     const { content } = await response.json();
      
      const notificacoesOrdenadas = [...content]
      .sort((a, b) => {
        if (a.lida !== b.lida) {
          return a.lida ? 1 : -1;
        }
        return new Date(b.createdAt) - new Date(a.createdAt);
      })
      .slice(0, 20);
      
      setNotificacoes(notificacoesOrdenadas);
      setNaoLidas(notificacoesOrdenadas.filter(n => !n.lida).length);
      setErroAPI(false);
    } catch (error) {
      console.error("Erro ao carregar notificações:", error);
      setErroAPI(true);
      setNotificacoes([]);
    }
  };

  const marcarComoLida = async (id) => {
    try {
      const user = sessionStorage.getItem("user");
      if (!user) return;
      
      const { access_token } = JSON.parse(user);
      await fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/notificacoes/lida/${id}`, {
        method: "PUT",
        headers: {
          'Content-Type': 'application/json',
          'Authentication': access_token
        },
        body: JSON.stringify({})
      });
      
      setNotificacoes(notificacoes.map(n => 
        n.id === id ? { ...n, lida: true } : n
      ));
      setNaoLidas(prev => prev - 1);
    } catch (error) {
      console.error("Erro ao marcar notificação como lida:", error);
    }
  };

  useEffect(() => {
    if (!userId) return;

    carregarNotificacoes();
    const interval = setInterval(carregarNotificacoes, 30000);
    return () => clearInterval(interval);
  }, [userId]);

  return (
    <NotificacaoContext.Provider 
      value={{ 
        notificacoes, 
        naoLidas, 
        marcarComoLida,
        atualizarUserId,
        erroAPI
      }}
    >
      {children}
    </NotificacaoContext.Provider>
  );
};

export const useNotificacao = () => useContext(NotificacaoContext);